// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyCanv4-7cTRRO-_omQvFkd6HKCFhRpaiCU",
    authDomain: "acfcollective-6f458.firebaseapp.com",
    projectId: "acfcollective-6f458",
    storageBucket: "acfcollective-6f458.firebasestorage.app",
    messagingSenderId: "280172843664",
    appId: "1:280172843664:web:eb3f9f413f8ebd9805fe15",
    measurementId: "G-VNXMPCTW41"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
// Initialize Firebase services
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);

export default app;